import {StoreService, StoreServiceInstance} from "@/services/storeService";

export class AutoStartAppService {
    private KEY = 'autoStartAllApp';
    constructor(
        private storeService: StoreService
    ) {
        if (!storeService.getMetaData(this.KEY)) {
            storeService.setMetaData(this.KEY, {});
        }
    }

    public update(userId, value) {
        if (this.storeService.getMetaData(this.KEY)[userId]) {
            this.storeService.getMetaData(this.KEY)[userId].value = value;
            this.storeService.setMetaData(this.KEY, this.storeService.getMetaData(this.KEY))
        } else {
            this.storeService.setMetaData(this.KEY, {
                ...this.storeService.getMetaData(this.KEY),
                [userId]: { value, startedAppAfterLogin: true }
            })
        }
    }

    public isStartApp(userId) {
        try {
            if (this.storeService.getMetaData(this.KEY)[userId]?.value) {
                return !this.storeService.getMetaData(this.KEY)[userId].startedAppAfterLogin;
            } else {
                return false
            }
        } catch (e) {
            return false;
        }
    }

    public async resetStateAutoStart() {
        try {
            for (const key in this.storeService.getMetaData(this.KEY)) {
                if (key) {
                    this.storeService.getMetaData(this.KEY)[key].startedAppAfterLogin = false;
                }
            }
            await this.storeService.setMetaData(this.KEY, this.storeService.getMetaData(this.KEY));
        } catch (e) {
            console.log(e)
        }
    }

    public startApp(userId) {
        this.storeService.getMetaData(this.KEY)[userId].startedAppAfterLogin = true;
        this.storeService.setMetaData(this.KEY, this.storeService.getMetaData(this.KEY));
    }
    public getData(userId) {
        return this.storeService.getMetaData(this.KEY)[userId] || {};
    }
}

export default new AutoStartAppService(StoreServiceInstance);
